import { Grid, InputAdornment, TextField } from '@mui/material'
import React from 'react'

const FlowRate = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <TextField
      fullWidth
      label="Flow Rate"
      value={moduleValues?.['Flow Rate'] ?? ''}
      onChange={(e) => {
        const value = Number(e.target.value)
        if (value >= 1 && value <= 15) {
          setModuleValues((prev) => ({
            ...prev,
            ['Flow Rate']: e.target.value,
          }))
        }
      }}
      type="number"
      autoComplete='off'
      InputProps={{
        endAdornment: <InputAdornment position="end">L/Min</InputAdornment>,
      }}
    />
  </Grid>
)

export default FlowRate